import EmptyFail from '@digital-retail/ui-common/components/EmptyFail';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import RecommendedProducts from '../../components/RecommendedProducts/RecommendedProducts';
import apiConfig from '../../config/api/apiConfig';
import { constants } from '../../config/constants';
import { WithUrl } from '../../utils/WithUrl';
import { DynamicBanner } from './DynamicBanner/DynamicBanner';
import { InformationBox } from './InformationBox/InformationBox';
import { NoResultsStyles } from './NoResults.style';

export const NoResults = ({ regionCode, appCtx, isImageSearch, ...data }) => {
  const showRecommendedProducts = appCtx?.siteConfig?.toggles?.showRecommendedProducts ?? false;

  const bannerURl = apiConfig.getEnvironmentSpecificUrl(WithUrl('CATEGORY_BANNER', regionCode), 'www');
  const noResultLabel = {
    error: { failText1: 'Ocurrió un error', failText2: 'Por favor, intenta nuevamente.' },
    noResult: {
      noProductsText1: 'No encontramos resultados',
      noProductsText2: 'Intenta con otra imagen o busca en las categorías.',
    },
  };
  return (
    <div className="no-result">
      <div className="container">
        {isImageSearch ? (
          <div className="image-container">
            <EmptyFail isNoResult labels={noResultLabel} />
          </div>
        ) : (
          <InformationBox title={data.title} description={data.description} term={data.term} />
        )}
        {showRecommendedProducts && (
          <div className="recommended-products-container">
            <LazyLoad>
              <RecommendedProducts pageName={constants.PAGE_NAME.NO_RESULT} slots="XLP-HRT-1" site="so_com" />
            </LazyLoad>
          </div>
        )}
        <DynamicBanner url={bannerURl} />
      </div>
      <style jsx>{NoResultsStyles}</style>
    </div>
  );
};

NoResults.defaultProps = {
  labels: {},
  description: '',
  term: '',
  appCtx: {},
  isImageSearch: false,
};

NoResults.propTypes = {
  regionCode: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  term: PropTypes.string,
  labels: PropTypes.object,
  appCtx: PropTypes.object,
  isImageSearch: PropTypes.bool,
};
